import * as React from 'react';
import { IMicrositeCounts } from '@nkr/models/index';
import { Nav } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from './styles';

interface IProps {
    counts: IMicrositeCounts,
    activeKey: string,
    isAdmin: boolean,
    isNkrLogin: boolean,
    isMicrositeCoach: boolean,
    centerId: number
}

class MicrositeNav extends React.Component<IProps, {}> {
    render = () => {
        const hrefPrefix = !this.props.isAdmin ? `/center/${this.props.centerId}/microsite` : `/admin/microsite`;
        const tabWidth = '230';

        return (
            <NavWrapper>
                <div style={{ padding: 20, backgroundColor: 'white' }}>
                    <Nav bsStyle='pills' className='ms-pills'>
                        <NavItemWrapper active={this.props.activeKey == 'ALL'} href={hrefPrefix + '/all'} tabWidth={tabWidth}>
                            All <span className='type-count'>({this.props.counts.allCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'PENDING-PATIENT'} href={hrefPrefix + '/pending-patient'} tabWidth={tabWidth}>
                            Pending<br />Patient <span className='type-count'>({this.props.counts.pendingPatientCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'PENDING-CONFIRMATION'} href={hrefPrefix + '/pending-confirmation'} tabWidth={tabWidth}>
                            Pending<br />Conf. <span className='type-count'>({this.props.counts.pendingConfirmationCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'ACTIVE-STARTER-SITES'} href={hrefPrefix + '/active-starter-sites'} tabWidth={tabWidth}>
                            Active<br />Starter <span className='type-count'>({this.props.counts.activeStarterSiteCount})</span>
                        </NavItemWrapper>

                        {this.props.isNkrLogin && (<>
                            <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                            <NavItemWrapper active={this.props.activeKey == 'PENDING-CUSTOM-SITE-COACH'} href={hrefPrefix + '/pending-custom-site-coach'} tabWidth={tabWidth}>
                                Pending<br />Coach Approval <span className='type-count'>({this.props.counts.pendingCoachCount})</span>
                            </NavItemWrapper>
                        </>)}

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'PENDING-CENTER'} href={hrefPrefix + '/pending-center'} tabWidth={tabWidth}>
                            Pending<br />Center <span className='type-count'>({this.props.counts.pendingCenterCount})</span>
                        </NavItemWrapper>

                        {this.props.isNkrLogin && (
                            <>
                                <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={this.props.activeKey == 'PENDING-NKR'} href={hrefPrefix + '/pending-nkr'} tabWidth={tabWidth}>
                                    Pending<br />NKR <span className='type-count'>({this.props.counts.pendingNkrCount})</span>
                                </NavItemWrapper>
                            </>
                        )}

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'ACTIVE-CUSTOM-SITES'} href={hrefPrefix + '/active-custom-sites'} tabWidth={tabWidth}>
                            Active<br />Custom <span className='type-count'>({this.props.counts.activeCustomSiteCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'ACTIVE-POST-TXP-SITES'} href={hrefPrefix + '/active-post-txp-sites'} tabWidth={tabWidth}>
                            Active<br />Post Transplant <span className='type-count'>({this.props.counts.activePostTxpSiteCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'STAGNANT-SITES'} href={hrefPrefix + '/stagnant-sites'} tabWidth={tabWidth}>
                            Stagnant <span className='type-count'>({this.props.counts.stagnantMicrositeCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'DISAPPROVED'} href={hrefPrefix + '/disapproved'} tabWidth={tabWidth}>
                            Disapproved <span className='type-count'>({this.props.counts.disapprovedCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'INACTIVE'} href={hrefPrefix + '/inactive'} tabWidth={tabWidth}>
                            Deactivated <span className='type-count'>({this.props.counts.inactiveCount})</span>
                        </NavItemWrapper>

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'CAMPAIGN-LIST'} href={hrefPrefix + '/campaigns'} tabWidth={tabWidth}>
                            Campaigns <span className='type-count'>({this.props.counts.campaignCount})</span>
                        </NavItemWrapper>

                        {this.props.isNkrLogin && (
                            <>
                                <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={this.props.activeKey == 'PENDING-CARDS'} href={hrefPrefix + '/pending-cards'} tabWidth={tabWidth}>
                                    Pending<br />Cards <span className='type-count'>({this.props.counts.pendingCardsCount})</span>
                                </NavItemWrapper>
                            </>
                        )}

                        {/* <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'DEACTIVATION-REQUESTS'} href={hrefPrefix + '/deactivation-requests'} tabWidth={tabWidth}>
                            Deactivation<br />Requests <span className='type-count'>({this.props.counts.deactivationRequestCount})</span>
                        </NavItemWrapper> */}

                        <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                        <NavItemWrapper active={this.props.activeKey == 'COACH-WAIT-LIST'} href={hrefPrefix + '/coach-wait-list'} tabWidth={tabWidth}>
                            Coach<br />Wait List <span className='type-count'>({this.props.counts.waitListCount})</span>
                        </NavItemWrapper>

                        {(this.props.isNkrLogin || this.props.isMicrositeCoach) && (
                            <>
                                <li role='presentation' className='li-divider'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={this.props.activeKey == 'MICROSITE-COACH'} href={'/microsite/coach'} target='_blank' tabWidth={tabWidth}>
                                    Microsite<br />Coach
                                </NavItemWrapper>
                            </>
                        )}
                    </Nav>
                </div>
            </NavWrapper>
        );
    }
}

export default MicrositeNav;